import { NameFormatted, SpriteType } from "./General";

export type ReplicaCategoryType = {
  id: string;
  name: string;
  subtitle?: string;
  index: number; // for sorting
};

export interface ReplicaCategoriesType {
  [key: string]: ReplicaCategoryType;
}

// e.g. 'Early Prop'
export type ReplicaSubVersionType = {
  id: string;
  name: string;
  thumbnail: any;
  gallery?: any[];
  video?: string;
  content?: any;
};

// e.g. 'v6'
export type ReplicaVersionType = {
  isWIP?: boolean;
  thumbnail?: string | SpriteType;
  thumbnailSize?: ThumbnailSize;
  background?: any;
  backgroundVideo?: any;
  version: string;
  isSeries?: boolean;
  page: any; // react component
  dateCreated?: Date;
  datePublished?: Date;
};

export enum ThumbnailSize {
  "L" = "L",
}

export type ReplicaType = {
  id: string;
  alternativeIds?: string[]; // for legacy URLs that don't match the current ID
  name: string;
  nameFormatted?: NameFormatted;
  origin: string;
  sort?: {
    preferredIndex?: number;
  };

  category: ReplicaCategoryType;

  versions: ReplicaVersionType[];
};

// Simpler version for miscellaneous replica items (no versions)
export type ReplicaItemType = {
  id: string;
  name: string;
  nameFormatted?: NameFormatted;
  page: any; // react component
  thumbnail?: string;
  background?: string | { src: string; opacity?: number };
};
